import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import useGetImportTable from "./hooks/useGetImportTable";
import CRMTable from "@metacrm/metacrm-material-ui/dist/Table";
import { map } from "lodash";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useOutletContext } from "react-router";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useIntl } from "react-intl";

export default function CustomerImportHistory() {
  const { formatMessage } = useIntl();
  const { headers, renderContents } = useGetImportTable();
  const [page, setPage] = useState(1);
  const [entityName] = useOutletContext();
  // const [orderData, setOrderData] = useState({ sort: "", order: 1 });
  const [importList, setImportList] = useState([]);
  const [importListCount, setImportListCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const dispatchSnackbar = useDispatchSnackbar();

  useEffect(() => {
    async function fetchHistory() {
      try {
        setIsLoading(true);
        const res = await axios.get(
          apiUrl + `/api/userSource/${entityName}/importHistory?page=${page}`
        );
        setImportList(res.data);
        setImportListCount(res.headers["x-total-count"]);
      } catch (err) {
        dispatchSnackbar({ err });
      } finally {
        setIsLoading(false);
      }
    }
    fetchHistory();
  }, [page]);

  return (
    <div>
      <Box className={"title"}>
        {formatMessage({ id: "importHistory.header.title" })}
      </Box>
      <Box className="description" mb="32px">
        {formatMessage({ id: "importHistory.header.description" })}
      </Box>
      <CRMTable
        containerStyle={{
          maxHeight: `calc(100vh - 172px)`,
        }}
        rowData={importList}
        // onRequestSort={handleRequestSort}
        // orderBy={orderData.sort}
        // order={_.get(orderData, "order") === 1 ? "asc" : "desc"}
        headers={headers}
        contents={map(importList, (importHistory, i) => {
          return renderContents(importHistory);
        })}
        isLoading={isLoading}
        noDataComponent={
          <EmptyIconStatus
            icon="table"
            wording="later"
            emptyTitle={formatMessage({ id: "emptyState.table.title" })}
            emptyDescription={formatMessage({
              id: "emptyState.table.description",
            })}
          />
        }
        page={page}
        setPage={setPage}
        dataCounts={importListCount}
        pageText={formatMessage({ id: "global.pagination.page" })}
        pageOfText={formatMessage({ id: "global.pagination.of" })}
      />
    </div>
  );
}
